import type { AuthConfig } from "@huub-web/auth";
import { parsePasswordStrengthLevel } from "@huub-web/auth";

import { legalContent } from "./legal";

const API_BASE_ENDPOINT = import.meta.env.VITE_API_BASE_ENDPOINT ?? "";

/**
 * Auth configuration for the Vite app.
 * Reads from Vite environment variables.
 */
export const authConfig: AuthConfig = {
  auth0: {
    domain: import.meta.env.VITE_AUTH0_DOMAIN ?? "",
    clientId: import.meta.env.VITE_AUTH0_CLIENT_ID ?? "",
    redirectUri: import.meta.env.VITE_AUTH0_REDIRECT_URI ?? "",
    audience: import.meta.env.VITE_AUTH0_AUDIENCE ?? "",
  },
  api: {
    verifyTokenEndpoint: `${API_BASE_ENDPOINT}/auth/verify`,
  },
  cookie: {
    name: import.meta.env.VITE_AUTH_COOKIE_NAME ?? "huub_id_token",
    domain: import.meta.env.VITE_AUTH_COOKIE_DOMAIN || undefined,
  },
  passwordStrengthLevel: parsePasswordStrengthLevel(
    import.meta.env.VITE_PASSWORD_STRENGTH_LEVEL,
  ),
  legalLinks: legalContent.links,
  legalNotice: legalContent.notice,
};

/**
 * Whether the Vite app uses its own in-app auth pages (`internal`, the
 * default) or redirects to an external login URL (`external`). `||`, not
 * `??`: CI passes an unset variable through as an empty string, which must
 * fall back to the default too.
 */
export const AUTH_MODE =
  (import.meta.env.VITE_AUTH_MODE as "internal" | "external") || "internal";
